import React, { useState, useEffect } from "react";
import { Box, IconButton } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import logoBlack from "../../assets/logo_black.png";
import logoWhite from "../../assets/logo_white.png";
import bee from "../../assets/bee.gif";  // Ensure bee image is imported
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

const Pics = () => {
    const location = useLocation();
    const isLandingPage = location.pathname === "/";

    const [isAtTop, setIsAtTop] = useState(true);

    const handleScroll = () => {
        const firstSectionHeight = window.innerHeight;
        setIsAtTop(window.scrollY < firstSectionHeight - 100); // Change logo when scrolled past 100px
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    // Prevent navigation if already on the homepage
    const handleLogoClick = (e) => {
        if (isLandingPage) {
            e.preventDefault(); // Prevent the link from navigating
        }
    };

    return (
        <>
            {/* Logo at the Top */}
            <Box
                sx={{
                    position: "fixed",
                    top: "20px",
                    left: "50px",
                    zIndex: 1000, // Higher z-index to keep on top
                }}
            >
                <Link to="/" onClick={handleLogoClick}>
                    <img
                        src={isLandingPage ? (isAtTop ? logoWhite : logoBlack) : logoBlack}
                        alt="LOGO"
                        style={{
                            width: "100px", // Adjust width, height will scale proportionally
                            height: "auto", // Keeps aspect ratio
                            transition: "opacity 0.3s ease-in-out",
                        }}
                    />
                </Link>
            </Box>

            {/* Bee Icon Always Floating */}
            {/* <Box
                sx={{
                    position: "fixed",
                    bottom: "20px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 1000, // Ensure bee stays on top
                }}
            >
                <img
                    src={bee}
                    alt="Bee Icon"
                    style={{
                        width: "100px", // Adjust size as needed
                        height: "auto",
                    }}
                />
            </Box> */}
            {!isAtTop && (
                <Box
                    sx={{
                        position: "fixed",
                        bottom: "20px",
                        left: "100%",
                        transform: "translateX(-50%)",
                        zIndex: 1000, // Ensure bee stays on top
                    }}
                >
                    <IconButton
                        onClick={scrollToTop}
                        sx={{
                            position: "fixed",
                            bottom: "30px",
                            right: "30px",
                            backgroundColor: "rgb(182, 163, 93)",
                            color: "white",
                            transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease",
                            "&:hover": {
                                backgroundColor: "rgb(150, 130, 75)",
                                boxShadow: "3px 3px 8px rgba(0, 0, 0, 0.2)",
                                transform: "scale(1.05)",
                            },

                            // backgroundColor: "rgba(0, 0, 0, 0.6)",
                            // color: "#fff",
                            // "&:hover": {
                            //     backgroundColor: "rgba(0, 0, 0, 0.8)",
                            // },
                        }}

                    >
                        <ArrowUpwardIcon />
                    </IconButton>
                </Box>
            )}
        </>
    );
};

export default Pics;
